<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-frais"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="consultRegleAttribution()">{{ data.libelle || '-' }}</a>
        </div>
        <ul class="lvi-attrs">
            <li><strong>{{ 'admin.frais.indemnites.reglesAttribution.liste.colonnes.modeGestion' | translate }}</strong> {{ getLibelleModeGestion() | translate }}</li>
            <li *ngIf="isInfosModeGestionVisible()"><strong>{{ getLibelleInfosModeGestion() | translate }}</strong> {{ getInfosModeGestion() }}</li>
            <li><strong>{{ 'admin.frais.indemnites.reglesAttribution.liste.colonnes.actif' | translate }}</strong> {{ data.actif ? ('global.oui' | translate) : ('global.non' | translate) }}</li>
            <li *ngIf="isTagDomaineVisible()"><strong>{{ 'admin.frais.referentiels.types.domaine' | translate }}</strong> {{ getValeurTagDomaine() }}</li>
            <li *ngIf="isTagPrestationsVisible()" [matTooltip]="getTooltipPrestations()"><strong>{{ getLibellePrestations() | translate }}</strong> {{ getValeurTagPrestations() }}</li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteRegleAttribution()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>
